import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagementService } from '../../service/user-management.service';
import { GroupManagementService } from '../../service/group-management.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../../shared/user.service';
import { DataTable } from 'primeng/primeng';

@Component({
  selector: 'app-group-recipient-list',
  templateUrl: './group-recipient-list.component.html',
  styleUrls: ['./group-recipient-list.component.css']
})
export class GroupRecipientListComponent implements OnInit {

  search: string = "";
  resultTable: any[] = null;
  userDetails: any = null;
  cols: any[];
  message: string = '';
  msgs: Message[] = [];
  listGroup: any[] = [];
  listGroupAddRmv: any[] = [];
  selectedGroup: any = null;
  selectedGroupAddRmv: any = null;
  btnAddRmv: boolean = false;
  @ViewChild('dt') dataTable: DataTable = null;
  flag: boolean;

  constructor(private dataService: UserManagementService, private groupService: GroupManagementService, private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.cols = [
      // { field: 'Id', header: '' },
      { field: 'LastName', header: 'שם משפחה' },
      { field: 'FirstName', header: 'שם פרטי' },
      { field: 'EMail', header: 'כתובת מייל' },
      //{ field: 'Phone1', header: 'טלפון' },
      //{ field: 'Phone2', header: 'טלפון נוסף' },
      //{ field: 'Address', header: 'כתובת' },
      //{ field: 'Active', header: 'פעיל' },
      { field: 'Notes', header: 'הערות' }
    ];

    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
        this.showMessage('error', '', 'Access denied');
      });

    this.groupService.getGroupDDL().subscribe((result: any) => {
      this.listGroupAddRmv = result;
      //this.listGroupAddRmv.unshift({ label: '', value: null });
    },
      (err: HttpErrorResponse) => {
        // this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת רשימת קבוצות');
      });

    this.groupService.getGroupDDL().subscribe((result: any) => {
      this.listGroup = result;
      this.listGroup.unshift({ label: 'כל הנמענים', value: null });

      this.getRecipientsByGroup();
    },
      (err: HttpErrorResponse) => {
        // this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.showMessage('error', '', 'תקלה בקבלת רשימת קבוצות');
      });

  }

  getRecipientsByGroup(): void {

    this.selectedGroup = this.selectedGroup === null ? '' : this.selectedGroup;
    this.groupService.getRecipientsByGroup(this.selectedGroup).subscribe((result: any) => {
      this.resultTable = result;
      this.dataTable.reset();
      this.setCheckboxValuesInArray(false);
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה באחזור נמענים לפי קבוצה');
      });
  }

  //editRecipient(id) {
  //  this.router.navigate(['recipient-edit/', id])
  //}

  GroupAdd() {
    if (this.selectedGroupAddRmv !== null && this.selectedGroupAddRmv !== undefined) {
      let newArr: any[] = [];
      this.resultTable.forEach(element => {
        if (element.Check === true && (element.Id !== null || element.Id !== undefined)) {
          newArr.push({ Id: element.Id, Check: element.Check });
        }
      });
      let ok = confirm(`האם ברצונך להוסיף ${newArr.length} נמענים לקבוצה?`);
      if (ok) {
        this.groupService.addRecipientsToGroup(this.selectedGroupAddRmv, newArr).subscribe((result: any) => {
          this.selectedGroupAddRmv = null;
          this.setCheckboxValuesInArray(false);
          this.showMessage('success', '', 'נמענים לקבוצה נשמרו');

        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בהוספת נמענים לקבוצה');
          });
      }
      else {
        newArr = [];
      }
    }
    else {
      this.showMessage('error', '', 'לא נבחרה קבוצה להוספת נמענים');
      return;
    }

  }

  GroupDel() {
    if (this.selectedGroup !== null && this.selectedGroup !== undefined) {
      let newArr: any[] = [];
      this.resultTable.forEach(element => {
        if (element.Check === true && (element.Id !== null || element.Id !== undefined)) {
          newArr.push({ Id: element.Id, Check: element.Check });
        }
      });
      let ok = confirm(`האם ברצונך להסיר ${newArr.length} נמענים מהקבוצה?`);
      if (ok) {
        this.groupService.deleteRecipientsFromGroup(this.selectedGroup, newArr).subscribe((result: any) => {
          this.selectedGroupAddRmv = null;
          this.setCheckboxValuesInArray(false);
          this.showMessage('success', '', 'נמענים הוסרו מהקבוצה');
          this.getRecipientsByGroup();
        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בהסרת נמענים מהקבוצה');
          });
      }
      else {
        newArr = [];
      }

    }
    else {
      this.showMessage('error', '', 'לא נבחרה קבוצה להוספת נמענים');
      return;
    }

  }

  setCheckboxValuesInArray(event: boolean): void {
    if (event) {
      let filteredValueCnt: number = -1;
      // try {
      //   filteredValueCnt = this.dataTable.filteredValue.length;
      // } catch (error) {
      //   filteredValueCnt = -1;
      // }
      try {
        if (this.dataTable) {
          if (this.dataTable.filteredValue) {
            filteredValueCnt = this.dataTable.filteredValue.length;
          }
          else {
            filteredValueCnt = -1;
          }
        }
        else {
          filteredValueCnt = -1;
        }
      } catch (error) {
        filteredValueCnt = -1;
      }

      if (filteredValueCnt === -1) {
        for (let i = 0; i < this.resultTable.length; i++) {
          let element = this.resultTable[i];
          if ((element.Id)) {
            this.setChecked(true, element.Id);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt > 0) {
        for (let i = 0; i < this.dataTable.filteredValue.length; i++) {
          let element = this.dataTable.filteredValue[i];
          if ((element.Id)) {
            this.setChecked(true, element.Id);
            this.flag = true;
          }
        }
      }
      else if (filteredValueCnt === 0) {
        this.flag = false;
        this.showMessage('info', '', 'לא נמצאו נתונים עבור הסינון שנבחר');
      }
    }
    else {
      for (let i = 0; i < this.resultTable.length; i++) {
        let element = this.resultTable[i];
        if ((element.Id)) {
          this.setChecked(false, element.Id);
          this.flag = false;
        }
      }
    }
  }

  setChecked(event: boolean, id: number): void {
    if (event) {
      let i = this.resultTable.findIndex(i => i.Id === id);
      if (i != -1) {
        this.resultTable[i].Check = true
      }
    }
    else {
      let i = this.resultTable.findIndex(i => i.Id === id);
      if (i != -1)
        this.resultTable[i].Check = false
    }
    this.setBtnAddRmv();
  }

  setBtnAddRmv(): void {
    let i = this.resultTable.findIndex(i => i.Check === true);
    let cnt = this.resultTable.filter(i => i.Check === true).length;
    if (i != -1 && cnt >= 1) {
      this.btnAddRmv = true;
    }
    else {
      this.btnAddRmv = false;
    }
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  showErrorSpecific() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' תקלה בהורדת קובץ' });
  }

}




// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/group-management/group-recipient-list/group-recipient-list.component.ts